module.exports = __webpack_public_path__ + "img/coupon_zhTc.c89f36d9.png";